import { render } from "./ChildOrgSearch.vue?vue&type=template&id=39259588"
import script from "./ChildOrgSearch.vue?vue&type=script&lang=js"
export * from "./ChildOrgSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__